module.exports = __webpack_public_path__ + "static/media/start.b44c37de.png";